import React from "react"
import classnames from "classnames"
import posting from "misago/services/posting"

export default function NavbarCreateZoneButton({ className, onClick }) {
  const handleClick = (event) => {
    event.preventDefault()
    
    if (onClick) {
      onClick(event)
    } else {
      // Open the same posting dialog that "Start thread" used to open
      posting.open({
        mode: "START",
        config: misago.get("THREAD_EDITOR_API"),
        submit: misago.get("THREADS_API"),
        // Don't specify category - let user choose in the dialog
      })
    }
  }

  return (
    <button
      className={classnames("btn btn-primary navbar-create-zone", className)}
      onClick={handleClick}
      type="button"
    >
      <span className="material-icon">add</span>
      <span className="create-zone-text">
        {pgettext("navbar", "Create a zone")}
      </span>
    </button>
  )
}